import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import "./footer.scss";

const Footer = (props) => {

    const [currentYear, setCurrentYear] = useState(0);

    useEffect(() => {
        const year = new Date();
        setCurrentYear(year.getFullYear());
    }, []);

    return (
        <footer className="wrapper_footer">
            <div className="container-fluid">
                <div className="row ">
                    <div className="col-sm-4 box_sociales">
                        <h6>Síguenos en</h6>
                        <p>
                            <span>
                                <a target="_blank" href="https://www.facebook.com/redvoucher">
                                    <i className="fab fa-facebook-square"></i>
                                </a>
                            </span>
                            <span>
                                <a
                                    target="_blank"
                                    href="https://youtu.be/abxBj7LPcio"
                                >
                                    <i className="fab fa-youtube"></i>
                                </a>
                            </span>
                            <span>
                                <a target="_blank" href="https://twitter.com/redvoucher">
                                    <svg style={{ margin: "0 0 6px 8px" }} viewBox="0 0 512 512" fill="#e94242" height="18px"><path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" /></svg>
                                </a>
                            </span>
                        </p>
                    </div>
                    <div className="col-sm-4 box_legal">
                        <h6>Soporte</h6>
                        <div className="box_flex justify_around align_center">
                            <ul>
                                <li>
                                    <a href={"mailto:contacto@redvoucheronline.com"}>
                                        <i className="fas fa-envelope pr-1"></i>contacto@redvoucheronline.com
                                    </a>
                                </li>
                                <li>
                                    <a href={"https://wa.me/5581050730"} target={"_blank"}>
                                    <span>
                                        <i className="fab fa-whatsapp"></i>
                                    </span> 5581050730
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-4 box_contacto">
                        <h6>Ventas</h6>
                        <ul>
                            <li>
                                <a href={"mailto:ventas@redvoucheronline.com"}>
                                    <i className="fas fa-envelope"></i> ventas@redvoucheronline.com
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={"row pie"}>
                    <div className="col-12 d-flex flex-column flex-md-row justify-content-center align-items-center">
                        <Link to="/notice-privacy" className="pr-lg-2 pr-md-2 pr-sm-0">
                            Aviso de privacidad
                        </Link>
                        <Link to="/terms-and-conditions" className="">
                            Términos y condiciones
                        </Link>
                    </div>
                </div>
                <div className="row pie">
                    <div className="col-sm-12">
                        <span>{currentYear} Red Voucher Online. Todos los derechos reservados.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
